import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import datasuiteApi from "../../../api/datasuiteApi";
import fileDownload from "js-file-download";
import { setExportButtonActive } from "../../../reducers/UIReducer/UIActions";
import useManufacturerData from "../../useManufacturerData/useManufacturerData";
import { getExportErrorMessage } from "./exportErrorMessages";

const useExportFiltersCard = () => {
    const dispatch = useDispatch();
    const { manufacturerParams } = useManufacturerData();

    const handleClickExportButton = (selectedFilters = [], includeCompetitiveData) => {
        dispatch(setExportButtonActive(false));
        var params = {};
        if (includeCompetitiveData) {
            params = {
                "chainData": selectedFilters?.chainData,
                "emergingData": selectedFilters?.emergingData,
                "startDate": moment(selectedFilters?.startDate).format('YYYY-MM-DD'),
                "endDate": moment(selectedFilters?.endDate).format('YYYY-MM-DD'),
                "categories": selectedFilters?.categories,
                "distributors": selectedFilters?.distributors,
                "locations": selectedFilters?.locations,
                "segments": selectedFilters?.segments,
                "states": selectedFilters?.states,
                "parentSizeMin": selectedFilters?.parentSizeMin ?? null,
                "parentSizeMax": selectedFilters?.parentSizeMax ?? null,
                ...manufacturerParams
            }
            if (selectedFilters?.categories?.length === 0 && selectedFilters?.locations?.length === 0) {
                toast.error("A Category or Operator filter is required for Competitive Data.");
                dispatch(setExportButtonActive(true));
            } else {
                const loadingToast = toast.loading("Fetching data. This may take a moment...");
                datasuiteApi.export.competitorItems.post(params).then((response) => {
                    toast.update(loadingToast, { render: "Downloading CSV file..", type: "success", isLoading: false, autoClose: "10000"});
                    fileDownload(response.data, "CompetitiveData_" + moment().format('DD-MM-YYYY_hmmss').toString() + ".csv");
                    dispatch(setExportButtonActive(true));
                }).catch((error) => {
                    toast.update(loadingToast, { render: getExportErrorMessage(error), type: "error", isLoading: false, autoClose: "10000"});
                    dispatch(setExportButtonActive(true));
                });
            }
        } else {
            params = {
                "chainData": selectedFilters?.chainData,
                "emergingData": selectedFilters?.emergingData,
                "startDate": moment(selectedFilters?.startDate).format('YYYY-MM-DD'),
                "endDate": moment(selectedFilters?.endDate).format('YYYY-MM-DD'),
                "categories": selectedFilters?.categories,
                "distributors": selectedFilters?.distributors,
                "locations": selectedFilters?.locations,
                "segments": selectedFilters?.segments,
                "states": selectedFilters?.states,
                "parentSizeMin": selectedFilters?.parentSizeMin ?? null,
                "parentSizeMax": selectedFilters?.parentSizeMax ?? null,
                ...manufacturerParams
            }
            const loadingToast = toast.loading("Fetching data. This may take a moment...");
            datasuiteApi.export.manufacturerItems.post(params).then((response) => {
                toast.update(loadingToast, { render: "Downloading CSV file..", type: "success", isLoading: false, autoClose: "10000"});
                fileDownload(response.data, "SalesData_" + moment().format('DD-MM-YYYY_hmmss').toString() + ".csv");
                dispatch(setExportButtonActive(true));
            }).catch((error) => {
                toast.update(loadingToast, { render: getExportErrorMessage(error), type: "error", isLoading: false, autoClose: "10000"});
                dispatch(setExportButtonActive(true));
            });
        }
    }

    return {
        handleClickExportButton
    }
}

// eslint-disable-next-line
export default { useExportFiltersCard };
